import type { LiveTeamRow, UsageDay } from "../api/types";
import { teamDailyRows } from "./calendar";

/** The month's peaks broken down by team — which sub-client filled the seats
 *  on the day the tree went over. */
export function TeamDailyTable({
  days,
  teams,
  included,
}: {
  days: UsageDay[];
  teams: LiveTeamRow[];
  included: number | null;
}): JSX.Element {
  const rows = teamDailyRows(
    days,
    teams.map((t) => t.slug),
    included,
  );
  const cell = { padding: "3px 10px", textAlign: "right" as const, borderBottom: "1px solid #eee" };
  return (
    <section style={{ marginBottom: 24 }}>
      <h2 style={{ fontSize: 18, margin: "0 0 8px" }}>By team, by day</h2>
      {rows.length === 0 ? (
        <p style={{ margin: 0, color: "#666" }}>Nothing yet this month.</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{ borderCollapse: "collapse", fontSize: 14 }}>
            <thead>
              <tr>
                <th style={{ ...cell, textAlign: "left" }}>Day</th>
                <th style={cell}>Tree</th>
                {teams.map((t) => (
                  <th key={t.slug} style={cell}>
                    {t.displayName}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.day}>
                  <td style={{ ...cell, textAlign: "left" }}>{r.day.slice(8)}</td>
                  <td style={{ ...cell, background: r.over ? "#fff3cd" : undefined }}>
                    {r.tree ?? ""}
                  </td>
                  {teams.map((t) => (
                    <td key={t.slug} style={cell}>
                      {r.byTeam[t.slug] ?? ""}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
